import { FC } from 'react';

import { Box, StyleProps } from '@bonusly/design-system';

import { UserAvatar } from '../../components/user-avatar';
import { Reaction } from './lib/reaction';
import { ReactionData } from './types';

interface ReactionAvatarProps extends StyleProps {
	reaction: ReactionData;
}

export const ReactionAvatar: FC<ReactionAvatarProps> = ({ reaction, ...rest }) => {
	const icon = Reaction.fromShortcode(reaction.emoji);

	return (
		<Box pos="relative" {...rest}>
			<UserAvatar user={reaction.user} />

			<Box position="absolute" bottom={'-0.4rem'} right={'-0.4rem'}>
				<icon.coin />
			</Box>
		</Box>
	);
};
